import { ISliderIndents } from '../../../../common/Slider';
import { DESKTOP_SLIDER_INDENTS, MOBILE_SLIDER_INDENTS } from '../constants';

interface IGetSliderIndentsParams {
  isMobile: boolean;
  isBetPositionVisible: boolean;
}

export function getSliderIndents(params: IGetSliderIndentsParams): ISliderIndents {
  const { isMobile, isBetPositionVisible } = params;

  if (isMobile) {
    return MOBILE_SLIDER_INDENTS;
  }

  if (isBetPositionVisible) {
    return DESKTOP_SLIDER_INDENTS;
  }

  return { ...DESKTOP_SLIDER_INDENTS, top: 0 };
}
